import React from 'react';
import { motion } from 'framer-motion';

const solo = [
    'Pagas tu viaje, pero no construyes una estrategia comercial',
    'Caminas 9 pabellones sin foco · agenda improvisada',
    'Te llenas de tarjetas que nunca se convierten en contratos',
    'Regresas con muchas ideas, pero sin una hoja de ruta para convertirlas en acciones',
    'La feria se olvida en 15 días. El ROI: cero.',
];

const tribu = [
    'Diagnóstico previo · sabes por qué vas y qué buscas',
    'Agenda B2B pre-armada con compradores reales para tu segmento objetivo',
    'Revisión diaria para analizar reuniones, ajustar la estrategia y preparar el siguiente día',
    'IA + LiveConnect · cada contacto capitalizado, no perdido',
    'Un plan de seguimiento durante los meses posteriores para convertir conversaciones en oportunidades reales',
];

const Col = ({ title, subtitle, items, kind }) => {
    const isPos = kind === 'tribu';
    return (
        <div
            className={`relative p-8 md:p-12 min-h-[520px] ${isPos ? 'bg-[color:var(--surface)]' : 'bg-[color:var(--bg)]'}`}
            style={isPos ? { boxShadow: '0 40px 100px -50px rgba(225,29,72,0.5)' } : undefined}
        >
            {isPos && (
                <div className="absolute top-0 left-0 right-0 h-[3px] bg-[color:var(--brand)]" />
            )}
            <div className="flex items-center justify-between mb-6">
                <div className={`eyebrow-brand ${isPos ? '' : 'text-white/50'}`} style={isPos ? undefined : { color: 'rgba(255,255,255,0.5)' }}>
                    {isPos ? 'Con la Tribu' : 'Ir solo'}
                </div>
                <span className={`text-xs uppercase tracking-[0.2em] ${isPos ? 'text-[color:var(--brand)]' : 'text-white/40'}`}>
                    {isPos ? 'Elige esta' : 'Evita esta'}
                </span>
            </div>

            <h3 className={`font-display text-4xl md:text-5xl mb-4 ${isPos ? 'text-white' : 'text-white/60'}`}>
                {title}
            </h3>
            <p className={`text-base leading-relaxed mb-8 ${isPos ? 'text-white/80' : 'text-white/50'}`}>
                {subtitle}
            </p>

            <ul className="space-y-4">
                {items.map((t, i) => (
                    <li key={i} className="flex items-start gap-3">
                        <span
                            className={`mt-1 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full text-[11px] font-bold ${
                                isPos
                                    ? 'bg-[color:var(--brand)] text-white'
                                    : 'bg-white/10 text-white/50'
                            }`}
                        >
                            {isPos ? '✓' : '✕'}
                        </span>
                        <span className={`text-sm md:text-base leading-relaxed ${isPos ? 'text-white/90' : 'text-white/55'}`}>
                            {t}
                        </span>
                    </li>
                ))}
            </ul>
        </div>
    );
};

const SoloVsTribu = () => (
    <section id="comparativo" className="relative py-16 md:py-20 border-t border-white/10 overflow-hidden bg-dots">
        <div className="mx-auto max-w-[1440px] px-6 md:px-10">
            <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-80px' }}
                transition={{ duration: 0.7 }}
                className="mb-8 max-w-4xl"
            >
                <div className="eyebrow-brand mb-6">La diferencia real</div>
                <h2 className="font-display text-white text-3xl sm:text-4xl md:text-5xl lg:text-6xl">
                    Ir a FITUR <span className="italic-accent text-white/40 font-normal line-through">solo</span>
                    <span className="italic-accent text-[color:var(--brand)] font-normal"> vs con la Tribu.</span>
                </h2>
                <p className="mt-6 text-white/70 text-lg leading-relaxed max-w-[62ch]">
                    Lo realmente costoso es regresar sin contactos relevantes, sin aprendizajes
                    y sin un plan para convertir conversaciones en oportunidades.
                </p>
            </motion.div>

            <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-80px' }}
                transition={{ duration: 0.8 }}
                className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/8 border border-white/10"
            >
                <Col
                    kind="solo"
                    title="Ir solo"
                    subtitle="La forma más cara de asistir a una feria: sin estrategia, sin agenda, sin retorno."
                    items={solo}
                />
                <Col
                    kind="tribu"
                    title="Con la Tribu Incubatour"
                    subtitle="El sistema probado que convierte 5 días de feria en un pipeline comercial de 12 meses."
                    items={tribu}
                />
            </motion.div>
        </div>
    </section>
);

export default SoloVsTribu;
